var _a, _b;
import { __assign } from "tslib";
import { handleActions } from 'redux-actions';
import ddt from '@wix/da-ddt';
import { actions as userActions } from '../../redux/users';
import { publishCommentSuccess } from '../../CommentEditor/redux/actionCreators';
import { reportComment, likeComment, unlikeComment, featureComment, requestSuccess, requestFailure, unfeatureComment, hideComment, unhideComment, updateCommentBadges, } from './actionCreators';
import { reduxKey } from './constants';
var actionHandler = handleActions((_a = {},
    _a[requestSuccess.toString()] = function (state, action) {
        return state;
    },
    _a[requestFailure.toString()] = function (state, action) {
        if (!action.payload) {
            return state;
        }
        switch (action.payload.actionType) {
            case featureComment.toString():
                return __assign(__assign({}, state), { isFeatured: false });
            case unfeatureComment.toString():
                return __assign(__assign({}, state), { isFeatured: true });
            case likeComment.toString():
                return __assign(__assign({}, state), { isLiked: false, likes: (state.likes || 0) - 1 });
            case unlikeComment.toString():
                return __assign(__assign({}, state), { isLiked: true, likes: (state.likes || 0) + 1 });
            case hideComment.toString():
                return __assign(__assign({}, state), { isHidden: false });
            case unhideComment.toString():
                return __assign(__assign({}, state), { isHidden: true });
            case reportComment.toString():
                return __assign(__assign({}, state), { isSpam: false });
            case userActions.blockUserFail.toString():
                // blocking user does nothing visually to the page, yet.
                return state;
            default:
                return state;
        }
    },
    _a[featureComment.toString()] = function (comment, action) {
        return __assign(__assign({}, comment), { isFeatured: true });
    },
    _a[unfeatureComment.toString()] = function (comment, action) {
        return __assign(__assign({}, comment), { isFeatured: false });
    },
    _a[likeComment.toString()] = function (comment, action) {
        if (!action.payload) {
            return comment;
        }
        var likes = (comment && comment.likes) || action.payload.comment.likes || 0;
        return __assign(__assign({}, comment), { isLiked: true, likes: likes + 1 });
    },
    _a[updateCommentBadges.toString()] = function (comment, action) {
        var _a;
        var payload = action.payload;
        if (!payload || !payload.comment) {
            return comment;
        }
        return __assign(__assign({}, action.payload.comment), { awardedBadges: (_a = payload.allBadges) !== null && _a !== void 0 ? _a : [] });
    },
    _a[unlikeComment.toString()] = function (comment, action) {
        if (!action.payload) {
            return comment;
        }
        var likes = (comment && comment.likes) || action.payload.comment.likes || 0;
        return __assign(__assign({}, comment), { isLiked: false, likes: likes - 1 });
    },
    _a[hideComment.toString()] = function (comment, action) {
        return __assign(__assign({}, comment), { isHidden: true });
    },
    _a[unhideComment.toString()] = function (comment, action) {
        return __assign(__assign({}, comment), { isHidden: false });
    },
    _a[reportComment.toString()] = function (comment, action) {
        return __assign(__assign({}, comment), { isSpam: true });
    },
    _a[publishCommentSuccess.toString()] = function (comment, action) {
        return __assign({}, action.payload.comment);
    },
    _a), {});
var reducers = (_b = {},
    _b[reduxKey] = function (state, action) {
        var _a;
        if (state === void 0) { state = {}; }
        var type = action.type, payload = action.payload;
        if (!payload || !payload.comment || !payload.comment.commentId) {
            // ddt.log('comments', 'ineligible event data: no commentid', action);
            return state;
        }
        ddt.log('comments', "EVENT: ".concat(type));
        var stateKey = payload.comment.commentId;
        var comment = state[stateKey] || payload.comment;
        var newState = actionHandler(comment, action);
        return __assign(__assign({}, state), (_a = {}, _a[stateKey] = newState, _a));
    },
    _b);
export default reducers;
//# sourceMappingURL=reducers.js.map